import React, { useRef, useState, useEffect } from 'react';
import { useOutsideClick } from '../../utils/helper';
import { useDropdown } from '../../context/DropDownContext';
import { useNavigate, useLocation } from 'react-router-dom';
import Topbar from '../PulseSurvey/Topbar';

const ShoorahTestDropdown = ({options}) => {
  const ref2 = useRef(null);
  const calendarRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const selectedTheme = JSON.parse(localStorage.getItem('selectedTheme'));



  const [isOpen2, setIsOpen2] = useState(false);
  const { selectedPage, setSelectedPage } = useDropdown();

  useEffect(() => {
    const currentPath = location.pathname;
    let currentPage = options[0];

    if (currentPath.includes('/test/b2c')) {
      currentPage = options.find((page) => page.value === 2);
    } else if (currentPath.includes('/test/b2b')) {
      currentPage = options.find((page) => page.value === 3);
    } else if (currentPath.includes('/test/tests-dashboard')) {
      currentPage = options.find((page) => page.value === 1);
    } else if (currentPath.includes('/test/partners')) {
      currentPage = options.find((page) => page.value === 4);
    }

    if (currentPage && currentPage.value !== selectedPage.value) {
      setSelectedPage(currentPage);
    }
  }, [location.pathname, selectedPage.value, setSelectedPage]);

  useOutsideClick(calendarRef, () => {
    setIsOpen2(false);
  });

  const handleMenuSelect = (item) => {
    console.log(item, 'selected item');
    setSelectedPage(item);
    setIsOpen2(false);
    navigate(item.path);
  };

  return (
    <div className="ms-5">
      <Topbar title={'Shoorah Tests'} />
      <div className="sm:flex flex-col md:flex-row mt-3 mb-3 justify-start items-start gap-3">
        <div className="flex flex-row items-center justify-center mt-2 sm:mt-0 space-y-2 sm:space-y-0 sm:space-x-2 w-full sm:w-auto">
          <div ref={ref2} className="relative inline-block text-left w-full md:w-auto mb-2 md:mb-0">
            <button
              type="button"
              onClick={() => setIsOpen2(!isOpen2)}
              className="flex justify-between items-center w-full md:w-auto px-5 py-2 text-xs md:text-base font-medium border dark:border-text-shoorah-darkBg border-[#0B1D2E] rounded-full dark:text-shoorah-darkBg dark:border-shoorah-darkBg"
            >
              <span>{selectedPage.name}</span>
              {selectedTheme ? (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                    stroke="#F3F4F6"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                    stroke="#0B1D2E"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </button>

            {isOpen2 && (
              <div
                className="z-50 absolute top-[2.5em] left-0 w-full sm:w-auto transform scale-90 sm:scale-100  mt-1 p-2 bg-white shadow-lg ring-1 ring-[#E7EAE8] dark:bg-shoorah-darkBgColor rounded-md"
                ref={calendarRef}
              >
                <ul className="bg-white dark:bg-shoorah-darkBgColor text-sm rounded-md divide-y divide-gray-200 dark:divide-shoorah-darkBorder">
                  {options.map((item) => (
                    <li
                      key={item.value}
                      className={`px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-800 cursor-pointer ${
                        selectedPage.value === item.value ? 'bg-gray-100 dark:bg-gray-800' : ''
                      }`}
                      onClick={() => handleMenuSelect(item)}
                    >
                      {item.name}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShoorahTestDropdown;
